import React, { useEffect, useState } from 'react';
import ElasticSearchAPIConnector from '@elastic/search-ui-elasticsearch-connector';
import {
  ErrorBoundary,
  Facet,
  SearchProvider,
  SearchBox,
  PagingInfo,
  Results,
  ResultsPerPage,
  Paging,
  Sorting,
  WithSearch,
} from '@elastic/react-search-ui';
import {
  Layout,
} from '@elastic/react-search-ui-views';
import JobCardList from '../job/JobCardList';
import { JobResult } from '../types/job';
import SearchHeader from '../header/SearchHeader';
import MobileFilterMenu from '../mobile/MobileFilterMenu';

// import moment from "moment";

import CustomPaginationView from '../pagination/CustomPaginationView';

import FacetContainer from '../customFacet';
import { ElasticResultsWrapper } from '../job/ElasticResultsWrapper';
// Common Elasticsearch API settings
const ELASTIC_CONFIG = {
  host: 'https://5d0493d4cacf44dbb8a0b25eefe15970.us-east-2.aws.elastic-cloud.com:443',
  apiKey: 'X1NVQ1E1Z0I2ZkxkWlpmbzBzN1A6QnpkM1dYazRTVjZ3aUZqR0F1dG1NUQ==',
  jobsIndex: 'jobs-north-america',
};

// Elasticsearch Connector for job listings
const connector = new ElasticSearchAPIConnector({
  host: ELASTIC_CONFIG.host,
  index: ELASTIC_CONFIG.jobsIndex,
  apiKey: ELASTIC_CONFIG.apiKey,
});

const config = {
  searchQuery: {
    search_fields: {
      job_title: {
        weight: 3,
      },
      job_description: {},
      location: {},
      client_description: {},
    },
    result_fields: {
      job_title: {
        raw: {},
      },
      job_description: {
        snippet: {},
      },
      location: {
        raw: {},
      },
      salary: {
        raw: {},
      },
      job_id: {
        raw: {},
      },
      posted_date: {
        raw: {},
      },
    },
    disjunctiveFacets: [
      'markets.enum',
      'global_filter_category.enum',
      'placement_types.enum',
      'offsite_pref_filter_option.enum',
    ],
    facets: {
      'markets.enum': { type: 'value' },
      'global_filter_category.enum': { type: 'value', size: 1000 },
      'placement_types.enum': { type: 'value' },
      'offsite_pref_filter_option.enum': { type: 'value' },
    },
  },
  autocompleteQuery: {
    results: {
      resultsPerPage: 5,
      search_fields: {
        job_title: {
          weight: 3,
        },
      },
      result_fields: {
        job_title: {
          snippet: {
            size: 100,
            fallback: true,
          },
        },
      },
    },
  },
  apiConnector: connector,
  alwaysSearchOnInitialLoad: true,
};

// const CustomResultView = ({ result, onClickLink }) => {
//   if (!result) return null;
//
//   const jobId = result.job_id?.raw || "";
//   const jobTitle = result.job_title?.raw || "";
//   const location = result.location?.raw || "";
//   const postedDate = result.posted_date?.raw || "";
//   const homeUrl = document.getElementById('listing-main')?.getAttribute('data-home-url') || '';
//   const jobBaseUrl = document.getElementById('listing-main')?.getAttribute('data-job-base-url') || '';
//   // Format the date
//   const formattedDate = postedDate
//     ? new Date(postedDate).toLocaleDateString("en-US", {
//         month: "short",
//         day: "numeric",
//         year: "numeric",
//       })
//     : "";
//     // Check if the job is new (posted within the last 7 days)
//     const isNewJob = (postedDate) => {
//       const postedDateObj = new Date(postedDate);
//       const sevenDaysAgo = new Date();
//       sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
//
//       return postedDateObj >= sevenDaysAgo;
//     };
//
//   return (
//     <a
//       href={`/find-work/${jobId}`}
//       title={jobTitle.replace(/<\/?em>/g, "")}
//       className="job-card"
//     >
//       <div
//         className="job-card__block"
//         role="region"
//         aria-labelledby={`job-title-${jobId}`}
//       >
//         <h2 className="job-card__title" id={`job-title-${jobId}`}>
//           {jobTitle.replace(/<\/?em>/g, "")}
//         </h2>
//         <p className="job-card__location">{location}</p>
//         <time className={`job-card__posted ${isNewJob(result.posted_date?.raw) ? "job-card__posted--new" : ""}`} itemProp="datePublished">
//           Posted {formattedDate}
//         </time>
//       </div>
//     </a>
//   );
//
// };

const JobListingMain = () => (
    <SearchProvider config={config}>
      <WithSearch mapContextToProps={({
        resultsPerPage, setResultsPerPage, setSearchTerm, searchTerm,
      }) => ({
        resultsPerPage, setResultsPerPage, setSearchTerm, searchTerm,
      })}>
        {({
          resultsPerPage, setResultsPerPage, setSearchTerm, searchTerm,
        }) => {
          React.useEffect(() => {
            if (resultsPerPage !== 12) {
              setResultsPerPage(12);
            }
          }, [resultsPerPage, setResultsPerPage]);

          return (
            <div className="job-search" id="job-listing">
              <SearchHeader setSearchTerm={setSearchTerm} searchTerm={searchTerm} />
              <ErrorBoundary>

                <Layout
                  header={<MobileFilterMenu />}
                  sideContent={

                    <div className="job-listing-sidebar">
                       <FacetContainer key={'3'} field={'global_filter_category.enum'} label={'Role'} showGlobalFilterSummary={true}/>
                      <FacetContainer key={'2'} field={'placement_types.enum'} label={'Placement Types'} />
                      <FacetContainer key={'1'} field={'markets.enum'} label={'Location'} />
                      <FacetContainer key={'4'} field={'offsite_pref_filter_option.enum'} label={'Location Preference'} />
                    </div>
                  }
                  bodyHeader={
                    <div className="job-listing-body-header">
                      <WithSearch mapContextToProps={({ totalResults }) => ({ totalResults })}>
                        {({ totalResults }) => (
                          totalResults > 0 ? (
                            <div className="job-results-count">
                              {totalResults} Results
                            </div>
                          ) : null
                        )}
                      </WithSearch>
                    </div>
                  }
                  bodyContent={
                  <div className="job-listing-body-results">
                    <ElasticResultsWrapper />
                  </div>
                  }
                  bodyFooter={
                    <div className="job-listing-body-footer">
                      <CustomPaginationView pagingContainer="test"/>
                    </div>
                  }
                />
              </ErrorBoundary>
            </div>
          );
        }}
      </WithSearch>
    </SearchProvider>
);

export { JobListingMain };
